<template>
    <div class="page page-kinkekaart">
        <div class="page-kinkekaart-sisu">
            <h2 data-translation-element="sisu-alampealkiri-kinkekaart">sisu-sisu-kinkekaart</h2>
            <div data-translation-element="sisu-sisu-kinkekaart">sisu-sisu-kinkekaart</div>
        </div>
        <hr class="hide-portrait"/>
        <div class="page-kinkekaart-button">
            <img class="kinkekaart-img" src="banners/kinkekaart2.png"/>
            <button class="btn btn-lg btn-active" @click="next" data-translation-element="sisu-kinkekaart-saldo">Vaata kaardi saldot</button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        next () {
            this.$emit('next');
        }
    }
}
</script>

<style lang="less">
    @import '../css/responsive';
    
    .page-kinkekaart {
        .kinkekaart-img {
            height: 14rem;
            object-fit: contain;
            margin-top: 1.8rem;
        }

        .page-kinkekaart-button {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .btn {
            align-self: center;
            margin: 1.6rem 0;
            padding: 0.8rem 9rem;
            font-weight: 500;
        }
    }

    @media @portrait {
        .page-kinkekaart {
            flex-direction: row !important;
        }
        .page-kinkekaart-button {
            margin-left: 2.4rem;
            justify-content: flex-start;
        }
    }
</style>